import React, { useEffect, useState, useCallback } from "react";
import { columnsUserEnquiry } from "../../Global Functions/columnsAntd";
import { useDispatch, useSelector } from "react-redux";
import { getUserEnquiriesList } from "../../Redux/Actions/enquiriesAction";
import TableComponentsCp from "../../Global Functions/tableComponentsCp";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";

const UserEnquiries = () => {
  const dispatch = useDispatch();
  const [tempSearch, setTempSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = useCallback(
    (page, limit, showLoader = true) => {
      const payload = {
        page,
        limit,
        is_deleted: false,
        filter: searchQuery,
      };
      dispatch(getUserEnquiriesList(payload, showLoader)).catch(() => {
        if (!showLoader) {
          toast.error("Failed to refresh User Enquiry List");
        }
      });
    },
    [dispatch, searchQuery]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  const { enquiries } = useSelector((state) => state.enquiries || {});
  const loading = useSelector((state) => state.rewards?.loading);

  useEffect(() => {
    if (enquiries?.total)
      setPagination((prevData) => ({ ...prevData, total: enquiries.total }));
  }, [enquiries]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const filterHandler = () => {
    setSearchQuery(tempSearch);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleDownloadExcel = async () => {
    try {
      const payload = {
        all: true,
        is_deleted: false,
      };

      const data = await dispatch(getUserEnquiriesList(payload));
      const rawData = data?.data?.data || []; 

      if (!Array.isArray(rawData) || rawData.length === 0) {
        toast.error("No enquiry data available to download");
        return;
      }

      const preparedData = rawData.map((item) => ({
        // EnquiryID: item._id,
        name: item.user?.name || "",
        country_code: (item.user?.country_code || "").replace(/^\+/, ""),
        phone: item.user?.contact_number || "",
        // ProjectName: item.project?.project_name || "",
        // ProjectBrand: item.project?.brand_name || "",
        // Type: item.type || "",
        // Count: item.count || 0,
        // CreatedAt: item.created_at
        //   ? new Date(item.created_at).toLocaleString()
        //   : "",
        // UpdatedAt: item.updated_at
        //   ? new Date(item.updated_at).toLocaleString()
        //   : "",
      }));

      const worksheet = XLSX.utils.json_to_sheet(preparedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "User Enquiries");
      XLSX.writeFile(workbook, "user_enquiries_list.xlsx");
    } catch (error) {
      toast.error("Failed to download enquiry data");
    }
  };

  return (
    <TableComponentsCp
      columns={columnsUserEnquiry}
      h3heading="User Enquiry List"
      pagination={pagination}
      dataSource={Array.isArray(enquiries?.data) ? enquiries.data : []}
      onChange={handleTableChange}
      setState={setTempSearch}
      filterFunction={filterHandler}
      loading={loading}
      onDownloadUser={handleDownloadExcel}
    />
  );
};

export default UserEnquiries;
